/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_Disabled_TitleInputs */



/**
* | output |
* | --- |
* | "Event Selection is disabled when Extended AD is enabled" |
*
* @param {Audio_Description_Export_Selection_Disabled_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_disabled_title = /** @type {((inputs?: Audio_Description_Export_Selection_Disabled_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_Disabled_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La sélection d'événements est désactivée lorsque l'AD étendue est activée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Ereignisauswahl ist deaktiviert, wenn Extended AD aktiviert ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La selezione degli eventi è disabilitata quando è abilitato l'AD esteso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Функция выбора событий отключена при включении расширенной функции Active Directory.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La selección de eventos está deshabilitada cuando AD extendido está habilitado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用扩展 AD 后，事件选择功能将被禁用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡張ADが有効な場合、イベント選択は無効になります")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्सटेंडेड AD सक्षम होने पर इवेंट चयन अक्षम हो जाता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A seleção de eventos é desativada quando o Active Directory estendido está ativado.")
	return /** @type {LocalizedString} */ ("Event Selection is disabled when Extended AD is enabled")
});